<template>
  <div class="container">
    <div class="title pf-medium">使用说明</div>
    <div class="main">{{ useDesc || '' }}</div>
  </div>
</template>

<script>
export default {
  props: {
    useDesc: {
      type: String,
      default: ''
    }
  },
  mounted() {},
  methods: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.container {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background: #fff;
  padding: rem(32px) 0 rem(16px) 0;

  .title {
    font-size: rem(30px);
    padding: 0 0 0 rem(24px);
  }

  .main {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.26rem;
    white-space: pre-wrap;
    color: #262626;
    padding: rem(24px);
    line-height: normal;
  }
}
</style>
